import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getMySubscription } from "../../Thunks/SiteMenuThunks";
import { SubscriptionPlan } from "../../Types/SiteMenuModel/MySubscription/SubscriptionPlan";
interface MySubscriptionSliceState {
    loader: boolean; // for refres pages and inital loadings
    mySubscriptionList: SubscriptionPlan[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : MySubscriptionSliceState = {
    loader: false,
    mySubscriptionList: [],
    errorDisplay: '',

}

// set state valu for api response
const mysubscriptionSlice = createSlice ({
    name: 'mySubscriptions',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getMySubscription.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getMySubscription.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getMySubscription.fulfilled, (state, action: PayloadAction<SubscriptionPlan[]>) => {
                    state.loader = false;
                    state.mySubscriptionList = action.payload;
                  })
    }
})

export const {} = mysubscriptionSlice.actions
export default mysubscriptionSlice.reducer
